/** Tiny app-wide event bus (window CustomEvents).
 * Keeps dashboards, Kanban and tables in sync instantly after any lead, staff
 * or meeting change without needing a page refresh. */
import { api } from './api';
import logger from './logger';

export const emitLeadChanged = (lead = null) => {
  window.dispatchEvent(new CustomEvent('lead:changed', { detail: lead }));
};

export const onLeadChanged = (cb) => {
  window.addEventListener('lead:changed', cb);
  return () => window.removeEventListener('lead:changed', cb);
};

export const emitStaffChanged = (staff = null) => {
  window.dispatchEvent(new CustomEvent('staff:changed', { detail: staff }));
};

export const onStaffChanged = (cb) => {
  window.addEventListener('staff:changed', cb);
  return () => window.removeEventListener('staff:changed', cb);
};

export const emitMeetingChanged = (meeting = null) => {
  window.dispatchEvent(new CustomEvent('meeting:changed', { detail: meeting }));
};

export const onMeetingChanged = (cb) => {
  window.addEventListener('meeting:changed', cb);
  return () => window.removeEventListener('meeting:changed', cb);
};

/** Open the global entity summary side panel for a lead, staff member or meeting. */
export const openSummaryPanel = (type, id) => {
  window.dispatchEvent(new CustomEvent('summary:open', { detail: { type, id } }));
};

export const onSummaryOpen = (cb) => {
  window.addEventListener('summary:open', cb);
  return () => window.removeEventListener('summary:open', cb);
};

/** Fire-and-forget audit trail for search clicks / record opens / errors.
 * Never blocks or breaks the UX — failures are logged to console only. */
export const logUiEvent = (action, { type = '', id = '', name = '', details = '' } = {}) => {
  api.post('/ui-events', { action, target_type: type, target_id: id, target_name: name, details })
    .catch((e) => logger.warn('ui-event audit skipped', e?.message));
};
